module.exports = __webpack_public_path__ + "img/yj_virtual_coin_bg.d32e2157.png";